import React, { useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import '../styles/VelocityWidget.css';

const VelocityWidget = ({
  speedDomain = [0, 100],
  onFilterChange,
  isExpanded,
  setIsExpanded,
  totalAuto = 0,
  highSpeedAuto = 0,
  mediumSpeedAuto = 0,
  lowSpeedAuto = 0,
  currentSpeed = 0
}) => {
  const [filters, setFilters] = useState({
    all: true,
    high: false,
    medium: false,
    low: false
  });

  const handleFilterChange = (filterKey) => {
    const newFilters = {
      ...filters,
      [filterKey]: !filters[filterKey]
    };
    setFilters(newFilters);

    // Notify parent component of filter changes
    if (onFilterChange) {
      onFilterChange(newFilters);
    }
  };

  // Calculate speed values
  const minSpeed = speedDomain[0].toFixed(1);
  const maxSpeed = speedDomain[1].toFixed(1);
  const midSpeed = currentSpeed > 0 ? currentSpeed.toFixed(1) : ((speedDomain[0] + speedDomain[1]) / 2).toFixed(1);

  // Calculate progress percentage for the indicator
  const progressPercentage = ((currentSpeed - speedDomain[0]) / (speedDomain[1] - speedDomain[0])) * 100;

  // Compact horizontal design matching screenshot
  return (
    <div className="velocity-widget-compact">
      <span className="velocity-label-min">{minSpeed}km/h</span>
      <div className="velocity-progress-bar-compact">
        <div className="velocity-gradient-bar"></div>
        <div className="velocity-center-label">Velocità</div>
      </div>
      <span className="velocity-label-max">{maxSpeed}km/h</span>
    </div>
  );
};

export default VelocityWidget;
